import { AnimatePresence } from "motion/react";
import { useContext, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import Card from "./Card";
import { ToolTipContext } from "./Context";
import { useTooltip } from "./useTooltip";

export const ToolTipPortal = ({ ...other }) => {
  const context = useContext(ToolTipContext);
  const [modalRoot, setModalRoot] = useState();
  const portalId = "tooltip-portal-root";

  const tooltip = context.getCurrentToolTip();

  useLayoutEffect(() => {
    let _modalRoot = document.getElementById(portalId);
    if (!_modalRoot) {
      _modalRoot = document.createElement("div");
      _modalRoot.setAttribute("id", portalId);
      document.body.append(_modalRoot);
    }
    setModalRoot(_modalRoot);
  }, []);

  if (!modalRoot) return null;

  return modalRoot
    ? createPortal(
        <AnimatePresence key="tooltip">
          {tooltip && tooltip.parent.current && (
            <Card key="tooltip" parentEl={tooltip.parent} {...other}>
              {tooltip.content}
            </Card>
          )}
        </AnimatePresence>,
        modalRoot
      )
    : null;
};

export { useTooltip };
